import { encodeQueryItem } from 'ufo';
import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime';

const operationsGenerator = createOperationsGenerator({
    keyMap: {
        width: 'w',
        height: 'h',
        dpr: 'dpr',
        fit: 'fit',
        quality: 'q',
        format: 'fm',
        background: 'bg',
    },
    valueMap: {
        fit: {
            contain: 'clip',
            outside: 'crop',
        },
    },
    joinWith: '&',
    formatter: (key: string, val: string) => encodeQueryItem(key, val),
});

const defaultModifiers = { format: 'auto' };

// https://kontent.ai/learn/docs/apis/image-transformation-api
export default defineProvider({
    getImage(src, { modifiers }) {
        const aspectModifiers = getAssetAspectModifiers(modifiers);
        const mergeModifiers = { ...defaultModifiers, ...modifiers, ...aspectModifiers };
        const operations = operationsGenerator(mergeModifiers as any);
        // console.log('kentico operations', operations, mergeModifiers);
        // https://<ZONE>/cdn-cgi/image/<OPTIONS>/<SOURCE-IMAGE>
        const url = operations ? `${src}?${operations}` : src;
        // console.log('final url', url);
        return {
            url,
        };
    },
});
